import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const categories = [
    { name: 'Vectors', path: '/?category=vectors' },
    { name: 'Photos', path: '/?category=photos' },
    { name: 'PSDs', path: '/?category=psds' },
    { name: 'Icons', path: '/?category=icons' },
    { name: 'Templates', path: '/?category=templates' },
  ];

  const closeMenu = () => setMobileMenuOpen(false);

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo" onClick={closeMenu}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 15V3M12 15L8 11M12 15L16 11M2 17L2 19C2 20.1046 2.89543 21 4 21L20 21C21.1046 21 22 20.1046 22 19V17" stroke="#4A90E2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>FreeFilesDownload</span>
        </Link>

        <button 
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`hamburger ${mobileMenuOpen ? 'open' : ''}`}></span>
        </button>

        {mobileMenuOpen && <div className="nav-backdrop" onClick={closeMenu}></div>}

        <nav className={`nav ${mobileMenuOpen ? 'nav-open' : ''}`}>
          <Link to="/" className="nav-link" onClick={closeMenu}>Browse</Link>
          <div className="nav-dropdown">
            <span className="nav-link dropdown-trigger">Categories</span>
            <div className="dropdown-menu">
              {categories.map((cat) => (
                <Link 
                  key={cat.name} 
                  to={cat.path} 
                  className="dropdown-item"
                  onClick={closeMenu}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
          <Link to="/contact" className="nav-link" onClick={closeMenu}>Contact</Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;
